<script>
    import jQuery from "jquery";
    import {getGPTransFunc} from "./gp-translations.js";
	import { flip } from 'svelte/animate';

	let trans = getGPTransFunc("gp-usersprojects");
    let mode = "open";
    let scheduledDelete = [];
    let timestamp;
    let pageSize = 10;
    let displayedSize = pageSize;
    export let projects;
    export let deleteFunction;
    $: displayedProjects = projects.filter((e,i) => i < displayedSize)
    $: showMore = projects.length > displayedProjects.length;

    let resolveOpening;

    export function open() {
        timestamp = Date.now();

        //manage focus
        jQuery('#GPOpen').on('show.bs.modal', GP.storeFocus);
        jQuery('#GPOpen').on('shown.bs.modal',function (){jQuery('.GPUserProjectsList .GPUsersProjectPanel:first-child').focus()});
        jQuery('#GPOpen').on('hidden.bs.modal', GP.restoreFocus);

        //trap focus
        jQuery('#GPOpen .close').on('keydown', function(e) {if (e.shiftKey && e.which===9) e.preventDefault();});
        jQuery('a.GPUsersProjectPanel').last().on('keydown', function(e) {if (!e.shiftKey && e.which===9) e.preventDefault();});
        
        jQuery('#GPOpen').modal({});
        jQuery('#GPOpen').on('hidden.bs.modal', () => this.$destroy());

        return new Promise(resolve => {
            resolveOpening = resolve;
        })
    }
    
    function userProjectSelectedForOpening (project) {
        GP.nextFocus = jQuery('#GPProjectView');
        jQuery('#GPOpen').modal('hide');
        resolveOpening(project);
    }
    
    function deleteProject (project) {
        if (mode !== "delete") return;
        
        projects.forEach((el) => {if (el === project) el.beingDeleted = true});
        projects = projects;

        scheduledDelete.push({
            timeout: setTimeout(function() {delayedDelete(project);}, 5000),
            proj: project
            });
        scheduledDelete = scheduledDelete;
        return false;
    }
    
    async function delayedDelete (project) {
        if (scheduledDelete.length > 0) {
            await deleteFunction(project.id);
            projects = projects.filter(el => el !== project);

            scheduledDelete = scheduledDelete.filter(el => el.proj !== project);
        }
    }
    
    function cancelDelete() {
        scheduledDelete.forEach((el) => {clearTimeout(el.timeout)})
        scheduledDelete = [];
        projects.forEach((el) => {el.beingDeleted = false});
        projects = projects;
    }

</script>

<div class=" modal fade GPModal" id="GPOpen">
    <div class="modal-dialog {mode==='delete'?'GPUsersProjectsDeleteMode':''}">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <h4 class="modal-title">{trans("Open project")}</h4>
                {#if scheduledDelete.length > 0}<a class="GPUsersProjectsCancelDelete" on:click="{cancelDelete}">{trans("Cancel")}</a>{/if}
                {#if projects.length > 0}<a class="GPUsersProjectsEdit" on:click={() => {mode = mode==="delete"?"open":"delete"}}>{trans("Edit")}</a>{/if}
            </div>
            <div class="modal-body">
                {#if displayedProjects.length}
                <div class="GPUserProjectsList">
                    {#each displayedProjects as project (project.id)}
                        <span class:beingDeleted="{project.beingDeleted}" animate:flip={{duration: 200}}>
                        <a tabindex="0" href="#" class="panel panel-default GPUsersProjectPanel" GPUsersProjectId="{project.id}" on:click="{() => userProjectSelectedForOpening(project)}">
                            <img src="{project.thumburl}?ts={timestamp}"/>
                            <div>{project.title}</div>
                            <div class="GPUsersProjectsDelete" on:click|stopPropagation={() => deleteProject(project)}>&times;</div>
                        </a>
                        </span>
                    {/each}
                </div>
                {:else}
                    <p>{trans("Empty! You have no projects saved yet.")}</p>
                {/if}
                {#if showMore}
                    <button on:click={() => {displayedSize += pageSize}} class="btn btn-primary">{trans("Show more")}</button>
                {/if}
            </div>
            <div class="modal-footer">
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->

</div><!-- /.modal -->
